export default "__VITE_ASSET__91f53d3f__"